import React, {Component} from 'react';
import {findDOMNode} from "react-dom";
import PropTypes from 'prop-types';

import Popover from 'src/core/gd-components/gd-popover/popover';

export default class InlineColorSelector extends Component {
    static propTypes = {
        className: PropTypes.string,                            // className for the outer element
        onChange: PropTypes.func,                               // onChange handler: function(newValue) {}
        colorPrefix: PropTypes.oneOf(["gd-c-","gd-c-bs-"]),
        value: PropTypes.any,                                   // initial field value

        type: PropTypes.oneOf(["default","default-26","rect","default-square-16"]),

        popoverClass: PropTypes.string,
        attachment: PropTypes.string,
        targetAttachment: PropTypes.string,

        options: PropTypes.array,

        allowSelectEmpty: PropTypes.bool,
        disabled: PropTypes.bool
    };

    static defaultProps = {
        colorPrefix: "gd-c-",
        type: "default",
        attachment: "top center",
        targetAttachment: "bottom center",
        disabled: false
    };

    state = {
        showPopover: false,
        value: this.props.value
    };

    // so we could modify from outside... new project color auto update
    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.value !== this.state.value) this.state.value=newProps.value;
    }

    showPopover = () => {
        if (!this.props.disabled)
            this.setState({showPopover: true})
    };

    hidePopover = () => {
        this.setState({showPopover: false})
    };

    onOptionClick = (value) => {
        this.setState({
            value: value,
            showPopover: false
        }, ()=>{
            if (this.props.onChange) this.props.onChange(value);
        });
    };

    getOptions = () => {
        let result = [];

        if (this.props.options) {
            result = this.props.options;
        } else {
            switch(this.props.colorPrefix) {
                // case "gd-c-": result = [22,3,14,15, 16,1,  11,9,8,6,20,17,18,19]; break;
                // TUT NA 1 men'she index chem core colors nado ukazivat' !!!!!!!!
                case "gd-c-": result = [27,20,6,28,9,29,11,30,31,14,15,16,32,1,33,3,34,35,22,36,19,37,38,17    ]; break;
                case "gd-c-bs-": result = [1,2,3,4,5,6,7,8,9,10]; break;
            }
        }

        return result;
    };

    renderValue = () => {
        const classes = Classes("color", "ui5-color-picker", this.props.colorPrefix+this.state.value, {
            'empty': !this.state.value
        });

        return (
            <div className="cur-val">
                <div className={classes}> </div>

                <span className="arrow-zone">
                    <span className="arrow i5-big-angle-down" />
                </span>
            </div>
        );
    };

    renderPopover = () => {
        if (this.state.showPopover) {
            const options = this.getOptions();

            return (
                <Popover className={Classes("gd-popover-color-content", {"with-unset-option": this.props.allowSelectEmpty})}
                         popoverClass={Classes("gd-popover-color", this.props.popoverClass)}
                         attachment={this.props.attachment}
                         targetAttachment={this.props.targetAttachment}
                         onClickOutside={()=>{this.hidePopover()}}
                         getTargetFunc={()=>findDOMNode(this)}>
                    <div className="gd-popover-color-header">Select color</div>

                    {options.map((value)=><div key={value} className={Classes("color", "ui5-color-picker", this.props.colorPrefix+value)} onClick={this.onOptionClick.bind(this,value)}/>)}

                    {this.props.allowSelectEmpty && <div className="color ui5-color-picker empty" onClick={this.onOptionClick.bind(this,null)}/>}

                    <div className="cf"/>
                </Popover>
            );
        } else {
            return null;
        }
    };

    render() {
        const classes = Classes('gd-inline-color', this.props.type+"-type", this.props.className, {
            disabled: this.props.disabled
        });

        return (
            <div className={classes} onClick={this.showPopover}>
                {this.renderValue()}
                {this.renderPopover()}
            </div>
        );
    }
}
